import oidc from './oidc';

export default {
  namespaced: true,
  modules: {
    oidc,
  },
};
